import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'svc-confirm-dialog',
  templateUrl: './svc-copilot-confirm-dialog.component.html',
  styleUrls: ['./svc-copilot-confirm-dialog.component.scss'],
})
export class SvcCopilotConfirmDialogComponent {
  public title: string;
  public text: string;
  public okText: string;
  public cancelText: string;
  public hideCloseButton: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef?: MatDialogRef<SvcCopilotConfirmDialogComponent>
  ) {
    this.title = data?.title ?? 'Atenção';
    this.text = data?.text;
    this.okText = data?.okText ?? 'Sim';
    this.cancelText = data?.cancelText ?? 'Cancelar';
    this.hideCloseButton = data?.hideCloseButton ?? false;

    this._dialogRef.disableClose = true;
  }

  ok(): void {
    this._dialogRef.close(true);
  }

  cancel(): void {
    this._dialogRef.close(false);
  }
}
